import { Box, Button, Tooltip } from '@chakra-ui/react';
import { ReactComponent as PatternIcon } from 'assets/icons/pattern.svg';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectEditBackgroundView } from 'modules/Editor/store/editorSettingsSelector';
import { setEditBackgroundView } from 'modules/Editor/store/editorSettingsSlice';
import { useTranslation } from 'react-i18next';

export const EditBackgroundPattern = () => {
  const { t } = useTranslation('editor_toolbar_page_menu', { useSuspense: false });
  const isEditBackgroundView = useAppSelector(selectEditBackgroundView);
  const dispatch = useAppDispatch();

  const onClick = () => {
    // Just switch tab without close side bar menu if currently NOT editing pattern
    if (isEditBackgroundView !== 'pattern') {
      dispatch(setEditBackgroundView('pattern'));
      return;
    }

    // Otherwise, just toggle
    dispatch(setEditBackgroundView(Boolean(isEditBackgroundView) ? undefined : 'pattern'));
  };

  return (
    <Box>
      <Tooltip label={t('editBackground.backgroundPattern')} hasArrow>
        <Button
          isActive={isEditBackgroundView === 'pattern'}
          onClick={onClick}
          size='sm'
          fontWeight='semibold'
          variant='ghost-with-active'
          w={8}
          h={8}
          gap={10}
          p={0.5}
          data-testid='pattern-menu-toolbar-btn'
        >
          <PatternIcon />
        </Button>
      </Tooltip>
    </Box>
  );
};
